"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainStateFactoryFromJS = exports.MainStateFactory = void 0;
const common_1 = require("@bimser/common");
const immutable_1 = require("immutable");
const _1 = require(".");
const pluginManager_1 = require("../pluginManager");
const { ExtremeGridsStateFactory, ExtremeGridsStateFactoryFromJS } = common_1.ExtremeGridEntities;
exports.MainStateFactory = (0, immutable_1.Record)({
    layout: (0, _1.LayoutStateFactory)(),
    plugins: (0, immutable_1.Map)(),
    user: (0, common_1.LoginStateFactory)(),
    modals: (0, common_1.ModalManagerStateFactory)(),
    hubConnection: (0, common_1.HubConnectionStateFactory)(),
    forms: (0, immutable_1.Map)(),
    system: (0, common_1.SystemStateFactory)(),
    ExtremeGrid: ExtremeGridsStateFactory(),
    UploadManager: common_1.UploadManagerEntities.UploadManagerStateFactory(),
    UITour: (0, common_1.UITourStateFactory)(),
    Viewers: common_1.DmViewerEntities.ViewerStateFactory(),
    environment: 'IDE'
});
const MainStateFactoryFromJS = function (data) {
    const items = Object.keys(data.plugins).reduce(function (previous, current) {
        previous[current] = (0, pluginManager_1.PluginStateItemFactoryFromJS)(data.plugins[current]);
        return previous;
    }, {});
    const forms = Object.keys(data.forms).reduce(function (previous, current) {
        previous[current] = common_1.FormsEntities.FormsStateFactoryFromJS(data.forms[current]);
        return previous;
    }, {});
    return (0, exports.MainStateFactory)({
        layout: (0, _1.LayoutStateFactoryFromJS)(data.layout),
        plugins: (0, immutable_1.Map)(items),
        user: (0, common_1.LoginStateFactoryFromJS)(data.user),
        modals: (0, common_1.ModalManagerStateFactoryFromJS)(data.modals),
        hubConnection: (0, common_1.HubConnectionStateFactoryFromJS)(data.hubConnection),
        forms: (0, immutable_1.Map)(forms),
        system: (0, common_1.SystemStateFactoryFromJS)(data.system),
        ExtremeGrid: ExtremeGridsStateFactoryFromJS(data.ExtremeGrid),
        UploadManager: common_1.UploadManagerEntities.UploadManagerStateFactoryFromJS(data.UploadManager),
        Viewers: common_1.DmViewerEntities.ViewerStateFactoryFromJS(data.Viewers),
        environment: data.environment
    });
};
exports.MainStateFactoryFromJS = MainStateFactoryFromJS;
//# sourceMappingURL=main.js.map